<template>
  <v-app>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <Header />
          <v-card class="mx-4 py-0 mb-n5 mt-9" style="z-index: 1">
            <v-card-title class="theme">
              <v-spacer />
              <div class="white--text display-1 font-weight-light">
                Register New Company
              </div>
              <v-spacer />
            </v-card-title>
          </v-card>
          <v-card class="elevation-0">
            <v-card-text>
              <div class="my-3">
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="login"
                  >login
                </v-btn>
                <v-btn
                  plain
                  small
                  class="caption theme-text text-capitalize"
                  @click="redirectToForgetPassword"
                  style="float: right"
                  >Forgot Password?
                </v-btn>
              </div>
              <v-alert :value="showAlert" type="warning">{{
                errorMessage
              }}</v-alert>
              <div class="px-4">
                <v-form ref="form" v-model="valid">
                  <v-row>
                    <v-col cols="12" class="mb-n3">
                      <div class="title ml-n2 theme-text">
                        Company Information
                      </div>
                    </v-col>
                    <v-col class="px-1 py-0" cols="6">
                      <v-text-field
                        v-model="name"
                        :disabled="temporaryDisable"
                        label="Company Name *"
                        validate-on-blur
                        type="text"
                        :rules="[validationRules.required]"
                        tabindex="1"
                        autocomplete="organization"
                        :autofocus="true"
                      />
                    </v-col>
                    <v-col class="px-1 py-0" cols="6">
                      <v-autocomplete
                        v-model="location"
                        :items="countries"
                        item-text="name"
                        return-object
                        :disabled="temporaryDisable"
                        label="Company Location *"
                        tabindex="2"
                        :rules="[validationRules.required]"
                        validate-on-blur
                        clearable
                      />
                    </v-col>
                    <v-col cols="12" class="mb-n3 mt-4">
                      <div class="title ml-n2 theme-text">
                        Contact Information
                      </div>
                    </v-col>
                    <v-col class="px-1 py-0" cols="6">
                      <v-text-field
                        v-model="fname"
                        label="First Name *"
                        validate-on-blur
                        :disabled="temporaryDisable"
                        type="text"
                        autocomplete="given-name"
                        tabindex="3"
                        :rules="[validationRules.required]"
                      />
                    </v-col>
                    <v-col class="px-1 py-0" cols="6">
                      <v-text-field
                        v-model="lname"
                        autocomplete="family-name"
                        :disabled="temporaryDisable"
                        validate-on-blur
                        label="Last Name *"
                        type="text"
                        tabindex="4"
                        :rules="[validationRules.required]"
                      />
                    </v-col>
                    <v-col class="px-1 py-0" cols="12">
                      <v-text-field
                        :disabled="temporaryDisable"
                        validate-on-blur
                        v-model="email"
                        autocomplete="email"
                        label="Work Email *"
                        hint="E.g. name@your-company.com"
                        persistent-hint
                        type="email"
                        tabindex="5"
                        :rules="[
                          validationRules.email,
                          validationRules.required,
                        ]"
                      />
                    </v-col>

                    <v-col class="px-1 py-0" cols="6">
                      <v-text-field
                        :disabled="temporaryDisable"
                        v-model="password"
                        label="Password *"
                        type="password"
                        tabindex="6"
                        validate-on-blur
                        autocomplete="new-password"
                        :rules="[
                          validationRules.password,
                          validationRules.required,
                        ]"
                      />
                    </v-col>
                    <v-col class="px-1 py-0" cols="6">
                      <v-text-field
                        v-model="confirmPassword"
                        :disabled="temporaryDisable"
                        label="Repeat Password *"
                        validate-on-blur
                        autocomplete="new-password"
                        type="password"
                        tabindex="7"
                        :rules="[confirmPasswordRules]"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </div>
            </v-card-text>

            <v-card-text>
              <div class="px-2 py-0 mt-0 font-weight-light">
                By creating your account you are accepting the
                <a
                  href="https://lessadmin.com/terms/privacy-policy"
                  class="text-decoration-none theme-text"
                  target="_blank"
                  >Privacy Policy</a
                >
                and
                <a
                  href="https://lessadmin.com/terms/terms-and-conditions"
                  class="text-decoration-none theme-text"
                  target="_blank"
                >
                  Terms and Conditions</a
                >
                of LessAdmin.
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                depressed
                class="mr-3 mt-n2 action white--text rounded-sm"
                :disabled="temporaryDisable"
                @click="register"
                tabindex="7"
                >Register
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">
            <v-spacer />
            <span>Please check your email !</span>
            <v-spacer />
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-xs-center pa-3">
            {{ registrationTextStart }}
            <br />
            <br />
            {{ registrationTextMiddle }}
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn class="save rounded-sm white--text" text @click="login"
              >OK</v-btn
            >
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

import Header from "../components/Header";

export default {
  name: Component.Auth.Register,
  data: () => ({
    valid: true,
    showAlert: false,
    errorMessage: "",
    name: "",
    fname: "",
    email: "",
    lname: "",
    password: "",
    location: {},
    confirmPassword: "",
    dialog: false,
    temporaryDisable: false,
    registrationTextStart: Constants.Messages.RegistrationOKStart,
    registrationTextMiddle: Constants.Messages.RegistrationOKMiddle,
  }),
  components: { Header },
  computed: {
    ...mapGetters(["countries"]),

    confirmPasswordRules() {
      if (!this.confirmPassword) return Constants.ConfirmPassword.Required;
      if (this.password === this.confirmPassword) return true;
      return Constants.ConfirmPassword.DoesNotMatch;
    },
  },
  methods: {
    login() {
      this.$router.replace("/");
    },
    register() {
      if (!this.$refs.form.validate()) {
        return false;
      }
      this.temporaryDisable = true;
      const payload = {
        email: this.email,
        last_name: this.lname,
        password: this.password,
        first_name: this.fname,
        company_name: this.name,
        location: this.location.name,
        location_code: this.location.code,
      };

      this.$store
        .dispatch(Actions.Activate, payload)
        .then((r) => {
          if (r.status === 200) {
            this.dialog = true;
            // let activationDetails = {
            //   email: this.email,
            //   companyID: r.data.companyID,
            //   namespace: r.data.namespace,
            // };
            // this.$store.dispatch(Actions.SendEmail, activationDetails).then(() => (this.dialog = true)).catch((e) => {
            //   this.showAlert = true;
            //   if (!e.response) {
            //     this.errorMessage =
            //         Constants.HttpErrResponse.GenericNetworkError;
            //   } else if (e.response.data && e.response.data.message) {
            //     this.errorMessage =
            //         Constants.HttpErrResponse.FBErrEmailLinkActivation;
            //   } else {
            //     this.errorMessage = Constants.HttpErrResponse.GenericError;
            //   }
            // }).finally(() => (this.temporaryDisable = false));
          } else if (r.status === 400) {
            this.showAlert = true;
            if (r.response.data && r.response.data.message) {
              this.errorMessage = r.response.data.message;
            } else {
              this.errorMessage =
                Constants.HttpErrResponse.RequestValidationErr;
            }
          }
        })
        .catch((e) => {
          this.showAlert = true;
          if (!e.response) {
            this.errorMessage = Constants.HttpErrResponse.GenericNetworkError;
          } else if (e.response.data && e.response.data.message) {
            this.errorMessage =
              Constants.HttpErrResponse.RegistrationErrorMessage;
          } else {
            this.errorMessage = Constants.HttpErrResponse.GenericError;
          }
        })
        .finally(() => (this.temporaryDisable = false));
    },
    redirectToForgetPassword() {
      this.$router.push({ name: Component.Auth.ResetPassword });
    },
  },
  created() {
    this.$store.dispatch(Actions.Countries);
  },
};
</script>

<style scoped>
.container {
  place-items: center center;
  background: radial-gradient(#9c1a5f, #551738) no-repeat;
}

.v-input {
  font-weight: 300;
}

div.v-alert.warning {
  border-radius: 3px;
}
</style>
